module.exports = "/lucky-balls/img/regular_game/header.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header.png
// module id = 1141
// module chunks = 0